/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBatchDownload = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M7 7h15v7h-2V9H9v11h2v2H7V7z" fill="currentcolor" />
      <path
        d="M2 2h15v3h-2V4H4v11h1v2H2V2zm16 12v4.586l1.793-1.793 1.414 1.414L17 22.414l-4.207-4.207 1.414-1.414L16 18.586V14h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBatchDownload as BatchDownload };
